import React, { useMemo, useState } from 'react';
import { Table } from '@shape-ds/components';
import { buildDateColumns } from 'components/ExternalReferencesTables/columsConfig';
import Filters from 'components/ExternalReferencesTables/Filters/Filters';
import { useVibrationAnalysisQuery } from 'queries/externalReferences/queries';
import { buildColumnsObject } from '@shape/lighthouse-components';
import dayjs from 'dayjs';
import { VibrationTable } from 'queries/externalReferences/contract';
import { sortDates } from 'utils';
import { t } from 'i18next';
import { DEFAULT_PERIOD } from './MaintenanceNotesTable';
import TableDataContainer from './TableData.container';
import { EVIDENCE_DEFAULT_PERIOD } from 'components/Evidences/hooks/useVibrationAnalysis';

interface VibrationAnalysisTableProps {
  assetId: string;
  className?: string;
  maxHeight?: number;
  isEvidenceTable?: boolean;
}
export const buildColumns = (data?: VibrationTable[]) => {
  if (data) {
    const dateColumnsUnsorted: string[] = [];
    for (let i = 0; i < data.length; i++) {
      Object.keys(data[i]).forEach((key) => {
        if (key === 'id') return;
        const stringDate = data[i][key].collection_date;

        dateColumnsUnsorted.push(dayjs(stringDate).format('YYYY-MM'));
      });
    }
    const cleanDateColumns = [...new Set(dateColumnsUnsorted)];
    const dateColumns = cleanDateColumns.sort((a, b) => sortDates(a, b, 'YYYY-MM'));
    return [
      ...buildColumnsObject<VibrationTable>({
        columns: { id: { enableSorting: false, size: 150 } },
        getLabel: (key: string) => t(`monitoring:tables.columns.VIBRATION_ANALYSIS.${key}`),
      }),
      ...buildDateColumns<VibrationTable>(dateColumns, 'MMM/YY'),
    ];
  }
  return [];
};

const VibrationAnalysisTable: React.FC<VibrationAnalysisTableProps> = ({
  assetId,
  className,
  maxHeight = 130,
  isEvidenceTable = false,
}) => {
  const [period, setPeriod] = useState<string>(
    isEvidenceTable ? EVIDENCE_DEFAULT_PERIOD : DEFAULT_PERIOD,
  );
  const { data, isLoading } = useVibrationAnalysisQuery(assetId, period);
  const [filteredData, setFilteredData] = useState<VibrationTable[]>(data || []);

  const columns = useMemo(() => buildColumns(data), [data]);
  //pegar endpoint vibration table edited, se isEvidenceTable for true fazer a chamada para esse endpoint e usar ele ao invés do filteredData

  return (
    <TableDataContainer
      isLoading={isLoading}
      dataLength={data?.length}
      className={`vibration-analysis ${className}`}
      type="VIBRATION_ANALYSIS"
    >
      {!isEvidenceTable && (
        <Filters
          data={data ?? []}
          onChangeFilters={(newData) => setFilteredData(newData)}
          setPeriod={setPeriod}
          period={period}
          searchKey={['id']}
        />
      )}
      {data && data.length > 0 && (
        <Table
          style={isEvidenceTable ? { maxHeight: '54vh', maxWidth: '66.5vw' } : { maxHeight }}
          data={filteredData}
          className="table"
          columns={columns}
        />
      )}
    </TableDataContainer>
  );
};

export default VibrationAnalysisTable;
